import NewAxiosInstance from "../../../api/api";
import {
  dispositionListApiType,
  usersDropdownListApiType,
} from "../../../types/tempTypes";
import { obj2url } from "../../../utils/utils";

export const dispositionListApi = async (data: dispositionListApiType) => {
  return await NewAxiosInstance().get(
    `/lead/disposition/tree?roles=${data.roles}`
  );
};

export const getUserDropdownListApi = async (
  data: usersDropdownListApiType
) => {
  return await NewAxiosInstance().get(
    `/crm/users?skip=0&take=20&userRole=SALES_AGENT` + obj2url(data)
  );
};
